"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRewards = exports.updateRewards = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const updater_1 = require("./updater");
const contracts_1 = require("./contracts");
const internalUseTransaction_1 = require("./internalUseTransaction");
const usePACTBalance_1 = require("./usePACTBalance");
const react_1 = tslib_1.__importStar(require("react"));
const updateRewards = async (provider, networkId, address) => {
    if (!address) {
        return;
    }
    const { donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
    const [estimated, claimable, currentEpoch, allocated] = await Promise.all([
        (0, updater_1.getEstimatedClaimableRewards)(donationMiner, address),
        (0, updater_1.getClaimableRewards)(donationMiner, address),
        (0, updater_1.getCurrentEpochEstimatedRewards)(donationMiner, address),
        (0, updater_1.getAllocatedRewards)(donationMiner, address)
    ]);
    return {
        allocated,
        claimable,
        currentEpoch,
        estimated
    };
};
exports.updateRewards = updateRewards;
const useRewards = () => {
    const { signer, provider, address, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const { setBalance } = react_1.default.useContext(ImpactProvider_1.PACTBalanceContext);
    const { rewards, setRewards } = react_1.default.useContext(ImpactProvider_1.RewardsContext);
    const executeTransaction = (0, internalUseTransaction_1.internalUseTransaction)();
    /**
     * Claims rewards.
     * @returns {ethers.TransactionReceipt} transaction response object
     */
    const claim = async () => {
        if (!signer || !address) {
            throw new Error('No signer');
        }
        try {
            const { donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
            const tx = await donationMiner.populateTransaction.claimRewards();
            const response = await executeTransaction(tx);
            setRewards(rewards => (Object.assign(Object.assign({}, rewards), { initialised: false })));
            const updatedRewards = await (0, exports.updateRewards)(provider, networkId, address);
            setRewards(rewards => (Object.assign(Object.assign(Object.assign({}, rewards), updatedRewards), { initialised: true })));
            const updatedPACTBalance = await (0, usePACTBalance_1.updatePACTBalance)(provider, networkId, address);
            setBalance(updatedPACTBalance);
            return response;
        }
        catch (error) {
            // console.log('Error in claim function: \n', error);
            setRewards(rewards => (Object.assign(Object.assign({}, rewards), { initialised: true })));
            throw error;
        }
    };
    (0, react_1.useEffect)(() => {
        if (address) {
            (0, exports.updateRewards)(provider, networkId, address).then(updatedRewards => setRewards(rewards => (Object.assign(Object.assign(Object.assign({}, rewards), updatedRewards), { initialised: true }))));
        }
    }, [address]);
    return { claim, rewards };
};
exports.useRewards = useRewards;
//# sourceMappingURL=useRewards.js.map